// Embedded input helpers - creates overlay inputs on document.body to avoid Phaser canvas event capture

let activeInput: HTMLDivElement | null = null;

export function initInputs() {
  // No pre-creation needed — we create on demand at document.body level
}

export function showInput(id: string, x: number, y: number, callback: (val: string) => void) {
  hideAllInputs();

  const container = document.getElementById('game-container')!;
  const rect = container.getBoundingClientRect();
  const scaleX = rect.width / 1280;
  const scaleY = rect.height / 720;

  // Create overlay container at body level (above Phaser canvas)
  const overlay = document.createElement('div');
  overlay.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;z-index:2147483647;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,0.35);';

  const input = document.createElement('input');
  const isPass = id.includes('pass') || id.includes('confirm');
  input.type = isPass ? 'password' : 'text';
  input.placeholder = id === 'nd-input-user' ? '输入用户名' : id === 'nd-input-pass' ? '输入密码' : id === 'nd-input-confirm' ? '再次输入密码' : id === 'nd-input-name' ? '输入新昵称' : '输入';
  input.maxLength = 16;
  input.autocomplete = 'off';

  const inputW = Math.round(320 * scaleX);
  const inputH = Math.round(44 * scaleY);
  const fs = Math.round(20 * Math.min(scaleX, scaleY));

  const left = rect.left + x * scaleX - inputW / 2;
  const top = rect.top + y * scaleY - inputH / 2;

  input.style.cssText = `
    position:fixed;left:${left}px;top:${top}px;width:${inputW}px;height:${inputH}px;
    font-size:${fs}px;padding:${Math.round(10 * scaleY)}px ${Math.round(16 * scaleX)}px;
    background:#0a0a1a;border:2px solid #00f0ff;color:#00f0ff;outline:none;
    border-radius:4px;font-family:Arial,sans-serif;
    box-shadow:0 0 20px rgba(0,240,255,0.4);
    z-index:2147483647;
  `;

  const commit = () => {
    const val = input.value;
    hideAllInputs();
    setTimeout(() => callback(val), 0);
  };

  const cancel = () => {
    hideAllInputs();
    setTimeout(() => callback(''), 0);
  };

  overlay.addEventListener('mousedown', (e) => {
    if (e.target === overlay) commit();
  });

  overlay.appendChild(input);
  document.body.appendChild(overlay);
  activeInput = overlay;

  requestAnimationFrame(() => { input.focus(); input.select(); });

  input.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') { e.preventDefault(); e.stopPropagation(); commit(); }
    else if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); cancel(); }
    else { e.stopPropagation(); }
  });
}

export function hideAllInputs() {
  if (activeInput) {
    if (activeInput.parentNode) activeInput.remove();
    activeInput = null;
  }
}

export function getInputValue(_id: string): string {
  return '';
}

export function repositionInputs() {
  // Handled via fixed positioning
}
